import { Component } from '@angular/core';

@Component({
  selector: 'renderstatic-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  standalone: false,
})
export class TermsOfUseComponent {}
